/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-shadow */
export enum PageType {
  Browse = 'Browse',
  MyContent = 'MyContent',
  RelatedResource = 'RelatedResource',
  Search = 'Search',
  Collection = 'Collection',
  Details = 'Details',
  Player = 'Player',
  Settings = 'Settings',
  Payment = 'Payment',
  Login = 'Login',
  SubscriptionInitiated = 'subscription-initiated',
  ViewPlans = 'View Plans',
  LinkDevice = 'Link Device',
  Language = 'Language',
  Watchlist = 'Watchlist',
  UpgradePlan = 'Upgrade Plan',
  Profiles = 'Profiles',
  Epg = 'Epg',
}
